import { Divider, Grid, Menu, MenuItem } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { cloneElement, forwardRef, useRef, useState } from 'react';
import { Button } from "../button/Button.js";
import { mergeRefs } from "../utils/mergeRefs.js";
import { useResizeObserver } from "../utils/ResizeObserver.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles({
  root: {
    overflow: 'hidden',
    height: '100%'
  }
}, {
  name: 'SD-AdaptiveVerticalToolbar'
});
var defaultMoreElement = /*#__PURE__*/_jsx(Button, {
  type: "button",
  children: /*#__PURE__*/_jsx(MoreHoriz, {})
});
export var AdaptiveVerticalToolbar = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    items,
    disableGutters,
    moreElement = defaultMoreElement,
    renderItem = item => item.label,
    renderMenuItem = item => item.label
  } = _ref;
  var styles = useStyles();
  var itemNodes = useRef([]);
  var optionsButtonRef = useRef(null);
  var [firstHiddenIdx, setFirstHiddenIdx] = useState(-1);
  var menuItems = firstHiddenIdx === -1 ? [] : items.slice(firstHiddenIdx);
  var [menuButtonNode, setMenuButtonRef] = useState();
  var [rootNode, setRootNode] = useState(null);
  useResizeObserver(rootNode, node => {
    var _optionsButtonRef$cur;
    var rootRect = node.getBoundingClientRect();
    var rootHeight = rootRect.bottom;
    var optionsButtonRect = (_optionsButtonRef$cur = optionsButtonRef.current) === null || _optionsButtonRef$cur === void 0 ? void 0 : _optionsButtonRef$cur.getBoundingClientRect();
    var optionsButtonWidth = (optionsButtonRect === null || optionsButtonRect === void 0 ? void 0 : optionsButtonRect.height) || 0;
    var maxBottomPosition = rootHeight - optionsButtonWidth;
    var mountedNodes = itemNodes.current.filter(x => x != null);
    var hiddenIdx = mountedNodes.findIndex((itemNode, idx) => {
      itemNode.removeAttribute('hidden');
      var itemRect = itemNode.getBoundingClientRect();

      // Ignore options button height when checking last item.
      if (idx === mountedNodes.length - 1) {
        return itemRect.bottom > rootHeight;
      }
      return itemRect.bottom > maxBottomPosition;
    });
    if (hiddenIdx !== -1) {
      mountedNodes.slice(hiddenIdx).forEach(itemNode => {
        itemNode.setAttribute('hidden', 'true');
      });
    }
    setFirstHiddenIdx(hiddenIdx);
  });
  return /*#__PURE__*/_jsxs(Grid, {
    direction: "column",
    container: true,
    wrap: "nowrap",
    className: styles.root,
    spacing: disableGutters ? undefined : 1,
    ref: mergeRefs(ref, node => {
      setRootNode(node);
    }),
    children: [items.map((item, idx) => /*#__PURE__*/_jsx(Grid, {
      item: true,
      ref: node => {
        itemNodes.current[idx] = node;
      },
      children: renderItem(item)
    }, item.key)), menuItems.length > 0 && /*#__PURE__*/_jsxs(Grid, {
      item: true,
      ref: optionsButtonRef,
      component: "div",
      children: [/*#__PURE__*/cloneElement(moreElement, {
        onClick: _ref2 => {
          var {
            currentTarget
          } = _ref2;
          setMenuButtonRef(currentTarget);
        }
      }), /*#__PURE__*/_jsx(Menu, {
        open: !!menuButtonNode,
        anchorEl: menuButtonNode,
        onClose: () => {
          setMenuButtonRef(undefined);
        },
        children: menuItems.flatMap((item, index, arr) => {
          var next = arr[index + 1];
          return [/*#__PURE__*/_jsx(MenuItem, {
            onClick: event => {
              var _item$onClick;
              (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, event);
              setMenuButtonRef(undefined);
            },
            children: renderMenuItem(item)
          }, item.key), next && next.menuGroupKey !== item.menuGroupKey && /*#__PURE__*/_jsx(Divider, {}, "".concat(item.key, "-divider"))];
        })
      })]
    })]
  });
});
if (process.env.NODE_ENV !== "production") AdaptiveVerticalToolbar.displayName = "AdaptiveVerticalToolbar";